var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _path, _circle, _circle2, _path2, _circle3, _circle4, _circle5, _circle6, _rect8, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveLanguageLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 154,
    viewBox: "0 0 260 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 6.125,
    width: 44,
    height: 44,
    transform: "rotate(-8 77 6.125)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.376 14.376L100.847 17.7277",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.902 16.3145L90.7923 19.1407",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.55 16.7856V16.7856C106.638 24.0658 102.342 30.4881 95.9623 34.1118L94.7052 34.8257",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.144 18.6695V18.6695C97.0281 25.4161 102.927 30.4057 110.059 32.1304L111.464 32.4703",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.9647,
    y: 5.34483,
    width: 45.8333,
    height: 45.8333,
    rx: 17.8397,
    transform: "rotate(-8 75.9647 5.34483)",
    stroke: "#FBE1AF",
    strokeWidth: 1.83333
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.184,
    y: 10,
    width: 48,
    height: 48,
    transform: "rotate(5 162.184 10)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.006 24.5059L184.684 28.1841",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.72 29.1494L173.65 27.2186",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.041 28.827V28.827C189.285 36.3416 183.143 42.1141 175.472 44.4002L173.961 44.8506",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.329 27.5402V27.5402C178.739 35.4192 183.785 42.1706 190.942 45.754L192.352 46.46",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 161.275,
    y: 8.91665,
    width: 50,
    height: 50,
    rx: 19.4615,
    transform: "rotate(5 161.275 8.91665)",
    stroke: "#FBE1AF",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 30.8242,
    width: 56,
    height: 56,
    transform: "rotate(-7 106 30.8242)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.563 41.8418L136.088 46.1174",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.915 44.543L123.262 47.6928",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 45.0683V45.0683C143.316 54.3123 137.708 62.3896 129.509 66.8591L127.893 67.7397",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.537 47.1681V47.1681C131.057 55.8174 138.454 62.2979 147.49 64.651L149.271 65.1147",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104.886,
    y: 29.9535,
    width: 58,
    height: 58,
    rx: 22.5385,
    transform: "rotate(-7 104.886 29.9535)",
    stroke: "#FBE1AF",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5088,
    y: 22,
    width: 48,
    height: 48,
    transform: "rotate(9 48.5088 22)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2637 38.0625L69.6861 41.7093",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.627 43.4424L58.7459 39.9768",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9802 42.8648V42.8648C73.706 50.1688 67.1764 55.4988 59.3648 57.2443L57.8257 57.5882",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3929 40.5541V40.5541C63.2498 48.5123 67.8127 55.5993 74.7026 59.6732L76.0601 60.4759",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6775,
    y: 20.8559,
    width: 50,
    height: 50,
    rx: 19.4615,
    transform: "rotate(9 47.6775 20.8559)",
    stroke: "#FBE1AF",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 80.9062,
    width: 56,
    height: 56,
    transform: "rotate(-4 116 80.9062)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.946 93.457L145.247 97.7542",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.139 96.8525L132.355 98.6555",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.84 97.1527V97.1527C152.035 106.315 146.011 114.087 137.59 118.122L135.93 118.917",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.653 98.3551V98.3551C139.716 107.177 146.762 114.036 155.664 116.858L157.418 117.415",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 114.933,
    y: 79.9784,
    width: 58,
    height: 58,
    rx: 22.5385,
    transform: "rotate(-4 114.933 79.9784)",
    stroke: "#FBE1AF",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.9062,
    y: 58.001,
    width: 56,
    height: 56,
    transform: "rotate(4 73.9062 58.001)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.824 74.457L100.524 78.7542",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.415 79.6562L87.6318 77.8533",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.119 79.3561V79.3561C106.056 88.1779 99.0091 95.0365 90.1078 97.8594L88.3539 98.4156",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9292 78.1537V78.1537C93.7343 87.3158 99.758 95.0884 108.18 99.1227L109.839 99.9176",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9784,
    y: 56.9337,
    width: 58,
    height: 58,
    rx: 22.5385,
    transform: "rotate(4 72.9784 56.9337)",
    stroke: "#FBE1AF",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11322_9755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.681,
    y: 54.001,
    width: 48,
    height: 48,
    transform: "rotate(8 167.681 54.001)",
    fill: "#E94524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.713 69.6816L189.199 73.338",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.169 74.8799L178.231 71.7967",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.512 74.3651V74.3651C193.366 81.7251 186.931 87.1683 179.151 89.0498L177.618 89.4205",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.886 72.3097V72.3097C182.882 80.2517 187.568 87.2579 194.528 91.211L195.899 91.9898",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 166.83,
    y: 52.8715,
    width: 50,
    height: 50,
    rx: 19.4615,
    transform: "rotate(8 166.83 52.8715)",
    stroke: "#FBE1AF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 96C54 94.8954 54.8954 94 56 94H76.2654C77.2607 94 78.1046 94.7319 78.2453 95.7172L81.7547 120.283C81.8954 121.268 82.7393 122 83.7346 122H184.265C185.261 122 186.105 121.268 186.245 120.283L189.755 95.7172C189.895 94.7319 190.739 94 191.735 94H212C213.105 94 214 94.8954 214 96V122V148C214 149.105 213.105 150 212 150H182H86H56C54.8954 150 54 149.105 54 148V122V96Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 128.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 61.5,
    r: 1.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20L32.5 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 11.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 26 154)",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90L11.5 94.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 23.5L241.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 76.5L254 80.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 6.125,
    width: 44,
    height: 44,
    rx: 16.9231,
    transform: "rotate(-8 77 6.125)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.184,
    y: 10,
    width: 48,
    height: 48,
    rx: 18.4615,
    transform: "rotate(5 162.184 10)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 30.8242,
    width: 56,
    height: 56,
    rx: 21.5385,
    transform: "rotate(-7 106 30.8242)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5088,
    y: 22,
    width: 48,
    height: 48,
    rx: 18.4615,
    transform: "rotate(9 48.5088 22)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 80.9062,
    width: 56,
    height: 56,
    rx: 21.5385,
    transform: "rotate(-4 116 80.9062)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.9062,
    y: 58.001,
    width: 56,
    height: 56,
    rx: 21.5385,
    transform: "rotate(4 73.9062 58.001)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11322_9755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.681,
    y: 54.001,
    width: 48,
    height: 48,
    rx: 18.4615,
    transform: "rotate(8 167.681 54.001)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveLanguageLearning);
export default __webpack_public_path__ + "static/media/collective-language-learning.723ce628b5375bb3dad5315ed413336c.svg";
export { ForwardRef as ReactComponent };